import { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './FormSearchBoxField.module.scss';


export type TFormSearchBoxFieldListOption = {
	value: string;
	text: string;
};

type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	disabled?: boolean;
};

export function FormSearchBoxFieldListItem(props: TProps) {
	const {
		children,
		disabled = false,
		...restProps
	} = props;

	const classNames = [styles.item];

	if (disabled) {
		classNames.push(styles.disabled);
	}

	return (
		<div className={ classNames.join(' ') } { ...restProps } >
			{ children }
		</div>
	);
}
